import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { ResendReleasePaymentHoldEntity } from "domain/entity/ResendReleasePaymentHold/ResendReleasePaymentHoldEntity";
import { ResendReleasePaymentHoldSearchCriteria } from "domain/entity/ResendReleasePaymentHold/ResendReleasePaymentHoldSearchCriteria";
import { axiosPostData } from "../axios/AxiosBasicImpl";
import documentAxiosInstance from "../axios/documentAxiosInstance";
import { ResendReleasePaymentHoldRepository } from "./ResendReleasePaymentHoldRepo";

/**
 * For template
 * @returns 
 */
export const ResendReleasePaymentHoldRepoImpl = (): ResendReleasePaymentHoldRepository => {

    const getEntities = async (request: ResendReleasePaymentHoldSearchCriteria): Promise<ResendReleasePaymentHoldEntity[]> => {
        const url = '/v1/releasePaymentHoldSearch';
        try {
            const res = await axiosPostData(documentAxiosInstance, url, request);
            const data = res.data;
            return data;
        } catch (err) {
            return [];
        }
    }

    const resend = async (rows: ResendReleasePaymentHoldEntity[]): Promise<ResponseEntity> => {
        const url = '/v1/releasePaymentHoldResend';
        return await axiosPostData(documentAxiosInstance, `${url}`, rows);
    }

    const updateEntities = async (rows: ResendReleasePaymentHoldEntity[]): Promise<ResponseEntity> => {
        const url = '/v1/updateReleasePaymentHold';
        return await axiosPostData(documentAxiosInstance, `${url}`, rows);
    }

    return {
        getEntities: getEntities,
        resend: resend,
        updateEntities: updateEntities
    }
}